import { html } from 'lit';

export const errorIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    role="img"
    aria-labelledby="errorIconTitle"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="square"
    stroke-linejoin="miter"
    fill="none"
    color="currentColor"
  >
    <title id="errorIconTitle">Error</title>
    <path d="M12 8L12 13" />
    <line x1="12" y1="16" x2="12" y2="16" />
    <circle cx="12" cy="12" r="10" />
  </svg>
`;
